import "./column-components.8ae02d44.js";
import "./column-components.89b08d55.js";
import "./column-components.298cc9f3.js";
import {createContext as $jFTsb$createContext, useContext as $jFTsb$useContext} from "react";
import {StatefulComponent as $jFTsb$StatefulComponent} from "@macrostrat/ui-components";
import $jFTsb$macrostrathyper from "@macrostrat/hyper";
import {compareAgeRanges as $jFTsb$compareAgeRanges, AgeRangeRelationship as $jFTsb$AgeRangeRelationship} from "@macrostrat/stratigraphy-utils";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;




var $7j1lu = parcelRequire("7j1lu");

var $7NDat = parcelRequire("7NDat");

var $aVUB5 = parcelRequire("aVUB5");

const $c86bb60129705c5e$export$20c7bffdb69233c9 = (0, $jFTsb$createContext)(null);
const $c86bb60129705c5e$var$buildColumnIndex = function() {
    /*
   * Find out where on the X axis arrows,
   * etc. should plot to aviod overlaps
   */ const heightTracker = [];
    return function(note) {
        let colIx = 0;
        // Get column that note should render in
        const nPossibleCols = heightTracker.length + 1;
        for(let column = 0, end = nPossibleCols, asc = 0 <= end; asc ? column <= end : column >= end; asc ? column++ : column--){
            if (heightTracker[column] == null) heightTracker[column] = note.height;
            if (heightTracker[column] < note.height) {
                const hy = note.top_height || note.height;
                heightTracker[column] = hy;
                colIx = column;
                break;
            }
        }
        return colIx;
    };
};
function $c86bb60129705c5e$var$withinDomain(scale) {
    const scaleDomain = scale.domain();
    return (d)=>{
        const noteRange = [
            d.height,
            d.top_height ?? d.height
        ];
        const rel = (0, $jFTsb$compareAgeRanges)(scaleDomain, noteRange);
        return rel !== (0, $jFTsb$AgeRangeRelationship).Disjoint;
    };
}
class $c86bb60129705c5e$export$c48860e5e2301a05 extends (0, $jFTsb$StatefulComponent) {
    static #_ = this.contextType = (0, $aVUB5.ColumnContext);
    static #_2 = this.defaultProps = {
        paddingLeft: 60,
        estimatedTextHeight (note, width) {
            const txt = note.note || "";
            return 12;
        }
    };
    constructor(props){
        super(props);
        this.computeContextValue = this.computeContextValue.bind(this);
        this.savedRendererForWidth = this.savedRendererForWidth.bind(this);
        this.generatePath = this.generatePath.bind(this);
        this.createNodeForNote = this.createNodeForNote.bind(this);
        this.computeForceLayout = this.computeForceLayout.bind(this);
        this.updateHeight = this.updateHeight.bind(this);
        this.updateNotes = this.updateNotes.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        // State is very minimal to start
        const { noteComponent: noteComponent } = this.props;
        this.state = {
            notes: [],
            elementHeights: {},
            columnIndex: {},
            nodes: {},
            generatePath: this.generatePath,
            createNodeForNote: this.createNodeForNote,
            noteComponent: noteComponent
        };
    }
    render() {
        const { children: children, width: width } = this.props;
        return (0, $jFTsb$macrostrathyper)($c86bb60129705c5e$export$20c7bffdb69233c9.Provider, {
            value: this.state
        }, (0, $jFTsb$macrostrathyper)((0, $aVUB5.ColumnLayoutProvider), {
            width: width
        }, children));
    }
    computeContextValue() {
        const { width: width, paddingLeft: paddingLeft } = this.props;
        // Clamp notes to within scale boundaries
        // (we could turn this off if desired)
        const { scaleClamped: scale } = this.context;
        const forwardedValues = {
            paddingLeft: // Forwarded values from column context
            // There may be a more elegant way to do this
            paddingLeft,
            scale: scale,
            width: width
        };
        // Compute force layout
        const renderer = new (0, $7NDat.Renderer)({
            direction: "right",
            layerGap: paddingLeft,
            nodeHeight: 5
        });
        return this.setState({
            renderer: renderer,
            updateHeight: this.updateHeight,
            generatePath: this.generatePath,
            ...forwardedValues
        });
    }
    savedRendererForWidth(width) {
        if (this._rendererIndex == null) this._rendererIndex = {};
        if (this._rendererIndex[width] == null) this._rendererIndex[width] = new (0, $7NDat.Renderer)({
            direction: "right",
            layerGap: width,
            nodeHeight: 5
        });
        return this._rendererIndex[width];
    }
    generatePath(node, pixelOffset) {
        const { paddingLeft: paddingLeft } = this.props;
        const renderer = this.savedRendererForWidth(paddingLeft - pixelOffset);
        try {
            return renderer.generatePath(node);
        } catch (err) {
            return null;
        }
    }
    createNodeForNote(note) {
        const { notes: notes, elementHeights: elementHeights } = this.state;
        let { scaleClamped: scale } = this.context;
        const { id: noteID } = note;
        const pixelHeight = elementHeights[noteID] || 10;
        const padding = 5;
        let noteHeight = scale(note.height);
        if ((0, $7j1lu.hasSpan)(note)) {
            const upperHeight = scale(note.top_height);
            const harr = [
                noteHeight - padding,
                upperHeight + padding
            ];
            if (harr[0] - harr[1] > 0) return new (0, $7NDat.FlexibleNode)(harr, pixelHeight);
            noteHeight = (harr[0] + harr[1]) / 2;
        }
        return new (0, $7NDat.Node)(noteHeight, pixelHeight);
    }
    computeForceLayout(prevProps, prevState) {
        let { notes: notes, nodes: nodes, elementHeights: elementHeights } = this.state;
        const { pixelHeight: pixelHeight } = this.context;
        const { width: width, paddingLeft: paddingLeft, forceOptions: forceOptions } = this.props;
        if (notes.length === 0) return;
        // Something is wrong...
        //return if elementHeights.length < notes.length
        // Return if we've already computed nodes
        const v1 = Object.keys(nodes).length === notes.length;
        if (prevState == null) prevState = {};
        const v2 = elementHeights === prevState.elementHeights || [];
        if (v1 && v2) return;
        const force = new (0, $7NDat.Force)({
            minPos: 0,
            maxPos: pixelHeight,
            nodeSpacing: 0,
            ...forceOptions
        });
        const dataNodes = notes.map(this.createNodeForNote);
        force.nodes(dataNodes).compute();
        const _nodes = force.nodes() ?? [];
        const nodesObj = {};
        for(let i = 0; i < _nodes.length; i++){
            const node = _nodes[i];
            const note = notes[i];
            nodesObj[note.id] = node;
        }
        return this.updateState({
            nodes: {
                $set: nodesObj
            }
        });
    }
    updateHeight(id, height) {
        if (height == null) return;
        const { elementHeights: elementHeights } = this.state;
        elementHeights[id] = height;
        return this.updateState({
            elementHeights: {
                $set: elementHeights
            }
        });
    }
    updateNotes() {
        // We received a new set of notes from props
        const { scaleClamped: scaleClamped } = this.context;
        const notes = this.props.notes.filter($c86bb60129705c5e$var$withinDomain(scaleClamped)).sort((a, b)=>a.height - b.height);
        const columnIndex = notes.map($c86bb60129705c5e$var$buildColumnIndex());
        return this.setState({
            notes: notes,
            columnIndex: columnIndex
        });
    }
    /*
   * Lifecycle methods
   */ componentDidMount() {
        this._previousContext = null;
        this.updateNotes();
        return this.computeContextValue();
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.notes !== prevProps.notes) this.updateNotes();
        // Update note component
        const { noteComponent: noteComponent } = this.props;
        if (noteComponent !== prevProps.noteComponent) this.setState({
            noteComponent: noteComponent
        });
        this.computeForceLayout.call(prevProps, prevState);
        if (this.props.notes === prevProps.notes) return;
        if (this.context === this._previousContext) return;
        this.computeContextValue();
        return this._previousContext = this.context;
    }
}
const $c86bb60129705c5e$export$b74b5a117fd60a1d = function(props) {
    let { padding: padding, width: width, ...rest } = props;
    if (padding == null) padding = 5;
    const { pixelHeight: pixelHeight } = (0, $jFTsb$useContext)((0, $aVUB5.ColumnContext));
    if (width == null) ({ width: width } = (0, $jFTsb$useContext)($c86bb60129705c5e$export$20c7bffdb69233c9));
    if (isNaN(width)) return null;
    return (0, $jFTsb$macrostrathyper)("rect", {
        width: width + 2 * padding,
        height: pixelHeight,
        transform: `translate(${-padding},${-padding})`,
        ...rest
    });
};
const $c86bb60129705c5e$export$53f13bca8c4c45d9 = function({ fill: fill, ...rest }) {
    if (fill == null) fill = "transparent";
    return (0, $jFTsb$macrostrathyper)($c86bb60129705c5e$export$b74b5a117fd60a1d, {
        className: "underlay",
        fill: fill,
        ...rest
    });
};
function $c86bb60129705c5e$export$77b5a6d4f65baae() {
    const ctx = (0, $jFTsb$useContext)($c86bb60129705c5e$export$20c7bffdb69233c9);
    if (ctx == null) throw new Error("useNoteLayout must be used within a NoteLayoutProvider");
    return ctx;
}


export {$c86bb60129705c5e$export$20c7bffdb69233c9 as NoteLayoutContext, $c86bb60129705c5e$export$c48860e5e2301a05 as NoteLayoutProvider, $c86bb60129705c5e$export$b74b5a117fd60a1d as NoteRect, $c86bb60129705c5e$export$53f13bca8c4c45d9 as NoteUnderlay, $c86bb60129705c5e$export$77b5a6d4f65baae as useNoteLayout};
//# sourceMappingURL=column-components.df0ea532.js.map
